import { Stack, Typography } from '@mui/material';
import LeadTimesTable from './Table/LeadTimesTable';
import useLeadTimesData from './Queries/LeadTimesDataQuery';
import ErrorPage from 'views/pages/maintenance/ErrorPage';
import LeadTimesSkeletons from './LeadTimesSkeletons';

export default function LeadTimesTab() {
	const { data, isLoading, isPending, isError } = useLeadTimesData();

	if (isError) {
		return <ErrorPage />;
	}

	if ((isLoading && !data) || isPending) {
		return <LeadTimesSkeletons />;
	}

	return (
		<Stack direction="column" spacing={4} margin={2}>
			<Stack direction="column" spacing={1}>
				<Typography
					variant="h2"
					sx={{
						paddingY: '8px',
					}}
				>
					LeadTimes por país
				</Typography>
				<Typography
					variant="body1"
					sx={{
						fontSize: '14px',
						fontFamily: 'Roboto',
						fontWeight: 400,
					}}
				>
					Configura los días estimados que demora cada etapa del proceso de
					abastecimiento.
				</Typography>
			</Stack>
			{/* <Stack direction="row" spacing={1} marginTop={2}>
				<Typography variant="body2" color="gray">
					Last update:
				</Typography>
				<Typography variant="body2" color="gray">
					12/06/2024.
				</Typography>
			</Stack> */}
			<LeadTimesTable rows={data} />
		</Stack>
	);
}
